<template>
  <div>
    <b-row class="px-2">
      <b-col class="col-md-4">
        <AppSearchInput
          :label="$t('search') + ':'"
          :placeholder="$t('search')"
          @callback="search"
        />
      </b-col>

      <b-col class="col-md-7 text-right ml-auto">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          v-b-modal.modal-pinned-usersModal
          style="margin-top: 18px"
          variant="primary"
        >
          <feather-icon icon="PlusIcon" size="16" />
          {{ $t("user_polzov") }}
        </b-button>
      </b-col>
      
      <b-col class="col-md-12">
        <b-table
          class="border"
          :fields="fields"
          :items="GET_WAREHOUSE_ID.results"
          show-empty
          hover
          responsive
          :empty-text="$t('empty_text')"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #cell(actions)="props">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              class="mt-50 mb-50"
              variant="danger"
              @click="deletePinnedUser(props)"
            >
              <feather-icon icon="TrashIcon" size="15" />
            </b-button>
          </template>
        </b-table>

        <Pagination class="mt-2" :rows="GET_WAREHOUSE_ID.count" @refresh="refresh" :params="filtered" :nobody="nobody" />
      </b-col>
    </b-row>

    <pinnedUsersModal :object="object" @refresh="refresh" />

  </div>
</template>

<script>
import { BButton, BCol, BRow, BTable } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import AppSearchInput from "@/components/AppSearchInput.vue";
import Pagination from "@/components/Pagination.vue";
import areYouSure from "@/mixins/areYouSure";
import pinnedUsersModal from "./modals/pinnedUsersModal.vue";


export default {
  components: {
    BButton,
    BTable,
    BCol,
    BRow,
    Pagination,
    AppSearchInput,
    pinnedUsersModal,
  },
  directives: {
    Ripple,
  },
  mixins: [areYouSure],
  props: {
    object: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      // ===============  PRIMARY_DATA_SECTION END ===============
      nobody: true,
      filtered: {
        page: 1,
        page_size: 10,
        search: "",
        is_object: 0,
      },
      editData: {},
      // ===============  PRIMARY_DATA_SECTION END ===============





      // ===============  OTHERS_SECTION END ===============
      fields: [
        {
          label: "№",
          key: "id",
        },
        {
          label:'namee',
          key: "title",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: 'actions',
          key: "actions",
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
      // ===============  OTHERS_SECTION END ===============





    };
  },
  computed: {
    ...mapGetters("obectsWarehouse", ["GET_WAREHOUSE_ID"]),
  },
  async mounted() {

    


    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.refresh();
    // ===============  PRIMARY_REQUESTS_SECTION START ===============




  },
  methods: {
    ...mapActions("obectsWarehouse", [
      "FETCH_WAREHOUSE_ID",
      "DELETE_USERS_PINNED",
      "UPDATE_WAREHOUSE",
      "FETCH_WAREHOUSE_LEFT_TABLE",
    ]),







    // ===============  DELETE_SECTION START ===============
    deletePinnedUser(props) {
      this.$_showAreYouSureModal().then((val) => {
        if (val) {
          this.UPDATE_WAREHOUSE({
            id: props.item.id,
            object: null,
          })
            .then(() => {
              this.FETCH_WAREHOUSE_LEFT_TABLE({
                object: this.object.id,
                is_object: 0,
              });
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },
    // ===============  DELETE_SECTION END ===============







    // ===============  FILTER_SECTION START ===============
    search(text) {
      if(this.object && this.object.id){
        this.filtered.search = text;
        this.filtered.object = this.object.id;
        this.FETCH_WAREHOUSE_LEFT_TABLE(this.filtered)
      }
    },
    // ===============  FILTER_SECTION END ===============






    // ===============  REFRESH_SECTION START ===============
    refresh() {
      if(this.object && this.object.id){
        this.filtered.object = this.object.id;
        this.FETCH_WAREHOUSE_LEFT_TABLE(this.filtered)
      }
    },
    // ===============  REFRESH_SECTION END ===============






    // ===============  ON_SUBMIT_SECTION START ===============
    save() {
      this.FETCH_WAREHOUSE_LEFT_TABLE({ object: this.object.id, is_object: 0 });
    },
    // ===============  ON_SUBMIT_SECTION END ===============




  },
};
</script>
